<template>
  <nav-create :title="institutionTitle" :add-label="$t('institution-list-add-institution-btn')"></nav-create>
</template>

<script>
import NavCreate from '@/components/nav/nav-create'
export default {
  components: { NavCreate },
  props: {
    institutionTitle: {
      type: String,
      required: true
    }
  }
}
</script>